import styled, { keyframes } from 'styled-components';

const notificationPulse = keyframes`
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.12);
  }
`;

export const StyledBlock = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
`;

export const NotificationDot = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  z-index: 2;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-sizing: border-box;
  pointer-events: none;
  /* Sidebar-bg ring keeps the fill visible on photos and the active turquoise border */
  background-color: ${({ theme }) => theme.color.brightTurquoise};
  border: 2px solid ${({ theme }) => theme.color.blackSqueeze};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.color.brightTurquoise};
  animation: ${notificationPulse} 1.8s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
